import React from 'react'
import s from './accessibility-alert.scss'
import {AccessibilityAlertProps} from './interfaces'

export const AccessibilityAlert = ({message}: AccessibilityAlertProps) => (
  <span role="alert" className={s.srOnly}>
    {message}
  </span>
)
